<mat-form-field appearance="outline" class="w-100 mb-3">
    <mat-label>Timezone</mat-label>
    <input matInput placeholder="Ex: America/New_York" [(ngModel)]="selectedTimezone" (ngModelChange)="onInput($event)"
        #timezoneModel="ngModel" [matAutocomplete]="auto" required>
    <mat-autocomplete #auto="matAutocomplete">
        @for (option of filteredOptions | async; track option) {
        <mat-option [value]="option">{{option}}</mat-option>
        }
    </mat-autocomplete>
    <mat-hint>Enter the time zone</mat-hint>
    <mat-error *ngIf="timezoneModel.errors?.['timezone']">Timezone is not valid</mat-error>
</mat-form-field>